<template lang="html">
    <div class="zxczxczxczxczx"></div>
</template>

<script>
export default {
    name: "gcPopup",

    methods: {
        insertBody() {
            document.body.insertBefore(
                "<div class='zxczxc'></div>",
                document.body.firstChild
            );
        }
    },

    mounted() {
        console.log("zxczxczxc");
        // this.insertBody();
    },

    created() {
        console.log("zxczxczxc");
    }
};
</script>

<style>
</style>